module.exports = __webpack_public_path__ + "static/media/sports_22.3c6f2836.jpg";